<template>
  <div class="tabs-list" style="margin-bottom: 75px">
    <template v-for="(item, $index) in tabs[1].list">
      <div :key="$index" class="tab-item" @click="goDetail(item)">
        <p class="tab-title">{{item.eventName}}</p>
        <div class="tab-label">
          <span>{{item.eventDate | showtime}}</span>
        </div>
      </div>
      <div v-if="$index==3 && ad" class="tab-item" :key="item.id">
        <Ad width="3.45rem" height="0.6rem" :content="ad" />
      </div>
    </template>
    <infinite-loading ref="gonggaoinf" @infinite="infiniteHandler" direction="bottom" :distance="100" :forceUseInfiniteWrapper="true">
      <div slot="no-more">无更多数据</div>
      <div v-if="tabs[0].list.length === 0" slot="no-results" class="no-results">
      </div>
      <div v-else slot="no-results">
      </div>
      <div slot="spinner" class="tab-spinner">正在加载...</div>
    </infinite-loading>
  </div>
</template>

<script>
import moment from 'moment'
import InfiniteLoading from 'vue-infinite-loading'
import { request } from '@/api/request'
import {mapState} from 'vuex'
import Ad from '../../advertisement/index.vue'

export default {
  computed: {
    ...mapState({
      code: state => state.code,
      market: state => state.market,
      tabs: state => state.common.tabs,
      symbol: state => state.symbol,
      tabIndex: state => state.common.tabIndex,
      ad: state => state.homeAdList[1]
    })
  },
  components: {InfiniteLoading, Ad},
  methods: {
    goDetail(gonggao) {
      // console.log('gonggao', gonggao)
      this.$router.push(`/detail/${this.market}/${this.symbol}/2/${gonggao.eventId}.html`)
    },
    async infiniteHandler($state) {
      let canload = await this.getListData()
      if (canload) $state.loaded()
      else $state.complete()
    },
    /**
     * 获取list 数据
     */
    async getListData() {
      let res = await request.get({
        url: request.apis.quote.articles,
        params: {
          market: this.market,
          symbol: this.code,
          pageNo: this.tabs[1].pageNo++,
          pageSize: 30,
          types: 2
        }
      })
      this.tabs[1].list = this.tabs[1].list.concat(res.list)
      if (res.list.length > 0) return true
      else return false
    }
  },
  filters: {
    showtime(_date) {
      let day = moment(new Date())
      let date = moment(_date)
      // if (day.year() === date.year() && day.dayOfYear() === date.dayOfYear()) {
        // return `${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      if (day.year() === date.year()) {
        return `${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)}`
      } else {
        return `${date.year()}-${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)}`
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.tabs-list
  display flex
  flex-flow column
  min-height 100vh
  .no-results
    background url('../../../assets/no_data.png')
    height 200px
    width 200px
    background-size cover
    margin 50px auto
  .tab-spinner
    font-size 13px
    padding 15px 0 30px 0
    color: #999
  .tab-item
    padding 10px 8px
    border-bottom 1px solid #f5f5f5
    .tab-title
      font-size 15px
      color #333
      // height 22px
      line-height 21px
      font-weight 400
      overflow:hidden; 
      text-overflow:ellipsis;
      display:-webkit-box; 
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2; 
    .tab-label
      display flex
      justify-content space-between
      font-size 12px
      color #999
      margin-top 5px
</style>